export default {
    Metadata: {
        Name: "isDirtyView",
        Description: "DEPRECATED: Use isDirtyForm().",
        Syntax: "IsDirtyView()",
        Keywords: ['Logical'],
        Author: "DataVoke, Inc.",
        UpdatesOnData: true
    },
    execute(mvc) {
        console.warn("DEPRECATED: isDirtyView will be deprecated, please use isDirtyForm()");
        try {
            if (typeof(mvc) == "undefined") {
                mvc = app.dv.helpers.exprEng.currexpression.mvc;
            }
            return app.dv.mvc.isDirty(mvc);

        } catch (e) {
            return false;
        }
        return false;
    },
};

